import * as React from 'react';
const LabbraSeccheEScrepolateIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M84.5 119.2c-20.7-5.58-28.53-21.11-28.53-21.11 13.35-17.1 32.39-25.64 44.04-13.68 11.65-11.97 30.68-3.42 44.04 13.68 0 0-1.6 3.16-5.25 7.15"
      className="prefix__cls-2"
    />
    <path
      d="M87.64 101.79c-16.73-1.04-31.68-3.7-31.68-3.7M144.04 98.09s-3.32.59-8.58 1.32"
      className="prefix__cls-2"
    />
    <path
      d="m110 118.98 5.39-6.29 5.4 1.8v4.49l2.7 3.6-1.8 5.4-6.3-2.7-4.49.9.9-3.6zM100.1 130.68l7.2-.9 3.6-3.6M110 118.98l-4.5-3.6h-1.8l-4.5 3.6-3.6 5.4"
      className="prefix__cls-1"
    />
    <path
      d="m103.7 115.38-1.8-2.69 4.5-3.6 8.09.9.9 2.7M116.29 96.49l-3.6 6.3 1.8 7.2M120.79 114.49l2.7-2.7.9-2.7-.9-2.7-.9-8.1M106.4 109.09l-.9-4.5 7.19-1.8M92.91 115.38l8.99-2.69-2.7-5.4.9-3.6 5.4.9"
      className="prefix__cls-1"
    />
    <path
      d="m130.69 107.29-2.7 1.8h-3.6M123.49 122.58l8.99-7.2M121.69 127.98l3.6 2.7M107.3 129.78l.9 4.49M100.1 103.69l-.9-2.7"
      className="prefix__cls-1"
    />
    <circle cx={112.69} cy={115.38} r={19.79} className="prefix__cls-1" />
  </svg>
);
export default LabbraSeccheEScrepolateIcon;
